import { render, staticRenderFns } from "./PaymentProfiles.vue?vue&type=template&id=00dd48c7&"
import script from "./PaymentProfiles.vue?vue&type=script&lang=js&"
export * from "./PaymentProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports